import { render, staticRenderFns } from "./ViewMergeAsset.vue?vue&type=template&id=30c86b20"
import script from "./ViewMergeAsset.vue?vue&type=script&lang=js"
export * from "./ViewMergeAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports